module.exports = __webpack_public_path__ + "assets/img/501.1b4368ca.png";